Auth = require 'app/scripts/db/auth'
ApiError = require 'app/scripts/network/api-error'
errorSignal = require 'app/scripts/lib/error-signal'
{ startTokenWatcher } = require '@trello/session-cookie'

errorSignal.subscribe ({ error }) ->
  if error instanceof ApiError.Unauthenticated
    Auth.logoutPost()
  return

startTokenWatcher()
